export enum BreakpointRangeName {
    SmallPhone = 'SmallPhone',
    Phone = 'Phone',
    Tablet = 'Tablet',
    Desktop = 'Desktop',
    LargeDesktop = 'LargeDesktop',
}
